/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedCollection = {
    init: function ($section) {
      // Add settings from schema to current object
      Shopify.theme.jsFeaturedCollection = $.extend(
        this,
        Shopify.theme.getSectionData($section)
      );

      let $sliderEl = $section.find("[data-slider]");

      if (this.collection_style == "slider") {
        this.createSlider($sliderEl);
      }
    },
    createSlider: function ($sliderEl) {
      const slideData = {
        products_per_slide: this.products_per,
        products_available: this.products_available,
        products_limit: this.products_limit,
      };

      const slider = $sliderEl.flickity({
        lazyLoad: 2,
        freeScroll: false,   
        imagesLoaded: true,
        draggable: true,
        cellAlign: "left",
        wrapAround: false,
        pageDots: false,
        contain: true,
        groupCells: slideData.products_per_slide || 1,
        prevNextButtons: slideData.products_limit > slideData.products_per_slide,
        initialIndex: 0,
        arrowShape: arrowShape,
      });

      // const flkty = $sliderEl.data('flickity');

      // flkty.on('change', function (index) {
      //   const currentSlide = index + 1;
      //   const totalSlides = flkty.slides.length;

      //   console.log(`Current Slide: ${currentSlide} / ${totalSlides}`);
      // });

      const barId =
        $sliderEl.attr("data-progressBarId") || $sliderEl.data("progressBarId"); // fallback if jQuery mapped it
 
      const $progressBar = $sliderEl.closest("section").find(`#${barId}`);

      if ($progressBar.length) {
        const updateBar = function (_evt, progress) {
          progress = Math.max(0, Math.min(1, progress || 0));
          $progressBar.css("width", progress * 100 + "%");
        };

        slider.on("ready.flickity", updateBar);

        slider.on("scroll.flickity", updateBar);

        slider.on("change.flickity", function () {
          const flkty = slider.data("flickity");
          const prog =
            flkty && flkty.slides && flkty.slides.length > 1
              ? (flkty.x / (flkty.maxX || 1)) * -1
              : 0;
          updateBar(null, prog);
        });
      }

      slider.on("settle.flickity", function () {
        slider.flickity("resize");
      });

      slider.on("settle.flickity", function () {
        slider.flickity("resize");
      });

      slider
        .find(".flickity-button")
        .empty()
        .html(
          `<svg fill="none" viewBox="0 0 15 24"><path fill="currentColor" d="M12.17 0L15 2.829l-9.339 9.175L15 21.171 12.17 24 0 12.004 12.17 0z"/></svg>`
        );
    },
    unload: function ($section) {
      let $slider = $section.find(".flickity-enabled");
      $slider.flickity("destroy");
    },
  };

  /******/
})();
